const initialState = {
  layoutType: '100%'
}

const SET_LAYOUT_TYPE = 'SET_LAYOUT_TYPE'

export const setLayoutType = (layoutType) => ({
  type: SET_LAYOUT_TYPE,
  payload: layoutType
})

const layoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LAYOUT_TYPE:
      return {
        ...state,
        layoutType: action.payload
      }
    default:
      return state
  }
}

export default layoutReducer
